import { render, staticRenderFns } from "./NotificationTemplateEditorModal.vue?vue&type=template&id=097b7bc7&scoped=true"
import script from "./NotificationTemplateEditorModal.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateEditorModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplateEditorModal.vue?vue&type=style&index=0&id=097b7bc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b7bc7",
  null
  
)

export default component.exports